"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigsValidationService = void 0;
var joi_1 = __importDefault(require("joi"));
var Result_1 = require("../../../../../models/concrete/Result");
var ConfigsValidationService = /** @class */ (function () {
    function ConfigsValidationService() {
        this.schemaForGetConfigs = joi_1.default.object().keys({}).optional();
    }
    ConfigsValidationService.prototype.getConfigsData = function (data) {
        var error = this.schemaForGetConfigs.validate(data).error;
        // debug
        console.debug('Validating get configs data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    return ConfigsValidationService;
}());
exports.ConfigsValidationService = ConfigsValidationService;
//# sourceMappingURL=ConfigsValidationService.js.map